import React from 'react';

import {DataInfo} from 'presentation/components';
import {Skeleton} from '@mui/material';
import {formatText} from 'presentation/utils';
import {useMediaQueries} from 'presentation/pages/private/hooks';
import {HealthSpecialtiesSectionProps} from './types';

export function HealthSpecialtiesSection({
	title,
	data,
	hasError,
	loading,
	iconName = 'stethoscope',
}: HealthSpecialtiesSectionProps) {
	const {isMobile} = useMediaQueries();

	if (loading) {
		return <Skeleton width={200} />;
	}

	if (hasError || !data) {
		return null;
	}

	const emptySpecialties = data.especialidades.length === 0;

	if (emptySpecialties) {
		return null;
	}

	const text = data.especialidades.map(specialty => specialty.descricao).join(', ');

	return (
		<DataInfo
			secondaryTextMaxWidth={isMobile ? '100%' : 280}
			primaryTextFontSize="1rem"
			secondaryTextFontSize="0.875rem"
			secondaryTextColor="text.secondary"
			primaryTextColor="text.primary"
			removeItemTextMargin
			iconName={iconName}
			primaryText={title}
			secondaryText={formatText(text)}
			removePaddingBottom
		/>
	);
}
